// notificationsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  counts: {
    // Key-value pairs for different notification types
    // cancellationRequests: 0,
    // inspectionRequests: 0,
    // requestEditAddress: 0,
    // orders: 0,
    // subscriptions: 0,
    // messages: 0,
    // support: 0,
  },
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationCount: (state, action) => {
      const { key, count } = action.payload;
      state.counts[key] = count;
    },
    clearNotificationCount: (state, action) => {
      const { key } = action.payload;
      state.counts[key] = 0;
    },
    incrementNotificationCount: (state, action) => {
      const { key, increment = 1 } = action.payload;
      state.counts[key] = (state.counts[key] || 0) + increment;
    },
    decrementNotificationCount: (state, action) => {
      const { key, decrement = 1 } = action.payload;
      state.counts[key] = Math.max((state.counts[key] || 0) - decrement, 0);
    },
    resetNotifications: (state) => {
      state.counts = {};
    },
  },
});

export const {
  setNotificationCount,
  clearNotificationCount,
  incrementNotificationCount,
  decrementNotificationCount,
  resetNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
